<template>
  <div>
    <editor
      :init="editorConfig"
      v-model="editorValue"
      tinymce-script-src="/tinymce/tinymce.min.js"
    />
  </div>
</template>

<script setup>
import { ref, watch, defineEmits, onMounted } from 'vue';

// 1. Import ตัว Editor component
import Editor from '@tinymce/tinymce-vue';

// 2. Import CSS ของ TinyMCE ที่จำเป็น
// CSS สำหรับ UI หลักของ Editor (เช่น toolbar, menu)
import 'tinymce/skins/ui/tinymce-5/skin.min.css'; // oxide, oxide-dark,tinymce-5, tinymce-5-dark
// import 'tinymce/skins/content/default/content.min.css';

// 3. Import ส่วนประกอบหลักของ TinyMCE
import 'tinymce/tinymce'; // Core
import 'tinymce/models/dom'; // Model
import 'tinymce/themes/silver'; // Theme
import 'tinymce/icons/default'; // Icons

// 4. Import ปลั๊กอินที่เราต้องการใช้งาน (ต้อง import ทุกตัวที่จะใช้)
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/table';
import 'tinymce/plugins/code';
import 'tinymce/plugins/wordcount';

const props = defineProps({
  content: {
    type: String,
    default: ''
  }
});
const emit = defineEmits(['update:content']);

// ตัวแปรสำหรับเก็บเนื้อหา
const editorValue = ref(null);

// 5. ตั้งค่า Editor
const editorConfig = {
  path_absolute: "/",
  height: 500,
  // menubar: true,
  menubar: 'edit insert format table',
  plugins: 'lists link image table code wordcount',
  toolbar: 'undo redo | fontfamily | fontsize  | bold italic | backcolor forecolor | alignleft aligncenter alignright | bullist numlist | link image | code',
  promotion: false,
  branding: false,
  skin: false,
  content_css: false,
};


watch(editorValue, (newValue) => {
  emit('update:content', newValue);
});
watch(() => props.content, (newValue) => {
  if (newValue && newValue !== editorValue.value) {
    editorValue.value = newValue;
  }
});
</script>

<style scoped>
/* สามารถเพิ่มสไตล์ที่นี่ได้ */
</style>